export default "__VITE_ASSET__BHd0SQRg__"